import { initWidget } from './widget';

import endpoints from './widget/define/endpoints';

import OrderList from './widget/component/OrderList';

const initOrderListPageWidgets = () => {
    const props = {
        endpoints,
    };

    initWidget('order-list', OrderList, props);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrderListPageWidgets.bind(this));
} else {
    initOrderListPageWidgets();
}